// "Ends …" label for a discount code's expires_at, in Eastern time.
//
// Admins usually pick midnight, and a code that expires at 12:00 AM on Oct 30
// stops working when Oct 30 begins — its last usable day is Oct 29. So a
// midnight expiry is shown as the previous day ("Ends Oct 29"); any other time
// is shown as-is ("Ends Oct 30, 5:00 PM ET").
const TZ = 'America/New_York';

export function formatPromoEnd(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';

  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(d)
      .map((p) => [p.type, p.value])
  );
  const atMidnight = Number(parts.hour) === 0 && Number(parts.minute) === 0;

  if (atMidnight) {
    // One minute earlier is 11:59 PM on the last valid day.
    const lastDay = new Date(d.getTime() - 60_000);
    return `Ends ${lastDay.toLocaleDateString('en-US', { timeZone: TZ, month: 'short', day: 'numeric' })}`;
  }
  const date = d.toLocaleDateString('en-US', { timeZone: TZ, month: 'short', day: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit' });
  return `Ends ${date}, ${time} ET`;
}

// "Online only" / "In person only" for a promo limited to one kind of seat on
// a hybrid event; '' otherwise.
export function promoModeLabel(promo) {
  if (promo?.attendance_mode === 'virtual') return 'Online only';
  if (promo?.attendance_mode === 'in_person') return 'In person only';
  return '';
}
